export async function getNetworkStatus() {
  // verify if the user is connected to a network
  const isConnectedToNetwork = navigator?.onLine;

  if (isConnectedToNetwork) {
    // verify if the network has signal by fetching a static file of the application
    // fetch auto-completes the url with the local origin if it's not on the string

    try {
      const networkResponse = await fetch(
        `https://www.letrus.com/favicon.ico`,
        {
          method: 'HEAD',
          cache: 'no-cache',
          mode: 'no-cors',
        },
      );

      // is called only when the fetch is sucessfull
      if (networkResponse) {
        return 'online';
      }
    } catch (error) {
      // if there is a network error
      // the fetch will fail and fall herre
      return 'offline';
    }
  }

  return 'offline';
}

interface OnlineOnlyParams {
  onlineCallback?(): void;
  offlineCallback?(): void;
}

// it is not possible to validate the network status on localhost

function checkNetworkStatus({
  onlineCallback,
  offlineCallback,
}: OnlineOnlyParams = {}): void {
  getNetworkStatus().then((networkStatus) => {
    if (networkStatus === 'online') {
      onlineCallback?.();
    } else {
      offlineCallback?.();
    }
  });
}

export default checkNetworkStatus;
